import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  model,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import type { SuiButtonGroupOption } from '@sui/button-group';

import { BulkScopeMode, GridBulkDialogData } from './grid-bulk-scope';

/**
 * The "apply to" picker at the top of a bulk config dialog (WAP-1731): the
 * ticked rows or every row the current filters return, with the two
 * descriptions under it. Takes the host's `GridBulkDialogData` snapshot and
 * holds the chosen mode as a two-way `mode` model (`[(mode)]="scopeMode"`);
 * the "selected" option is disabled while nothing is ticked. Declared in
 * DataGridModule.
 */
@Component({
  selector: 'app-grid-bulk-scope',
  templateUrl: './grid-bulk-scope.component.html',
  styleUrls: ['./grid-bulk-scope.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GridBulkScopeComponent {
  private readonly translate = inject(TranslateService);

  readonly data = input.required<GridBulkDialogData>();
  readonly mode = model.required<BulkScopeMode>();

  protected readonly options = computed<SuiButtonGroupOption[]>(() => {
    const { selectedIds, totalCount } = this.data();
    return [
      {
        value: 'ids',
        label: `${this.translate.instant('grid.bulk.scope.selected')} (${selectedIds.length})`,
        disabled: selectedIds.length === 0,
      },
      {
        value: 'filter',
        label: `${this.translate.instant('grid.bulk.scope.all-matching-filters')} (${totalCount})`,
      },
    ];
  });
}
